import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";
import Table from "../../Table/Table";
import { ICustomModalProp } from "./module/constants";

// Import style
import classes from "./CustomModal.module.scss";

const CustomModal = (props: ICustomModalProp) => {
  const { dataSource, size } = props;

  return (
    <>
      <Modal
        show={props.show}
        size={size ? size : "lg"}
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          {props.message && props.message}{" "}
          {props.dataSource && props.dataSource.length > 0 && (
            <Table
              rowsChangeable={false}
              showDetail={false}
              dataSource={dataSource}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className={`${classes.button}`} onClick={props.onClose}>
            <FormattedMessage {...messages.close} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomModal;
